export default {
  loading: false,
  submitting: false,
  form: null
}
